// src/features/error-management/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ErrorDashboardPage from './pages/ErrorDashboardPage';
import ErrorBrowserPage from './pages/ErrorBrowserPage';

export const ErrorManagementRoutes = () => (
  <>
    <Route
      path="errors"
      element={
        <ProtectedRoute requiredScope="admin-error:read">
          <ErrorDashboardPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="errors/browse"
      element={
        <ProtectedRoute requiredScope="admin-error:read">
          <ErrorBrowserPage />
        </ProtectedRoute>
      }
    />
  </>
);